<ng-container *ngIf="!customerTypeNumber">
  <div class="container register-step-1 px-0">
    <div class="col-md-8 col-lg-6 mx-auto">
      <div class="options" *ngIf="!isPrivalgoMarkets">
        <mat-radio-group class="radio-group">
          <div class="radio-option">
            <div class="radio-option-item">
              <mat-radio-button [value]="leadTypeString.Private" class="radio-button" [checked]="checked === leadTypeString.Private" disableRipple (change)="changeType($event)">Private</mat-radio-button>
            </div>
          </div>
          <div class="radio-option">
            <div class="radio-option-item">
              <mat-radio-button [value]="leadTypeString.Corporate" class="radio-button" [checked]="checked === leadTypeString.Corporate" disableRipple (change)="changeType($event)">Corporate</mat-radio-button>
            </div>
          </div>
          <div class="radio-option">
            <div class="radio-option-item">
              <mat-radio-button [value]="leadTypeString.Affiliate" class="radio-button" [checked]="checked === leadTypeString.Affiliate" disableRipple (change)="changeType($event)">Partner</mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
      </div>

      <div class="options" *ngIf="isPrivalgoMarkets">
        <mat-radio-group class="radio-group">
          <div class="radio-option">
            <div class="radio-option-item">
              <mat-radio-button [value]="leadTypeString.MarketsCorporate" class="radio-button" [checked]="checked === leadTypeString.MarketsCorporate" disableRipple (change)="changeType($event)">Corporate</mat-radio-button>
            </div>
          </div>
          <div class="radio-option">
            <div class="radio-option-item">
              <mat-radio-button [value]="leadTypeString.MarketsInstitution" class="radio-button" [checked]="checked === leadTypeString.MarketsInstitution" disableRipple (change)="changeType($event)">Institution</mat-radio-button>
            </div>
          </div>
          <div class="radio-option">
            <div class="radio-option-item">
              <mat-radio-button [value]="leadTypeString.MarketsPartner" class="radio-button" [checked]="checked === leadTypeString.MarketsPartner" disableRipple (change)="changeType($event)">Partner</mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
      </div>

      <form [formGroup]="registerForm" class="register-step1-form">
        <div class="col-12 px-0">
          <div class="form-group">
            <mat-form-field [ngClass]="{
                'is-invalid': (!registerForm.get('email').valid || emailExist || !emailValid) && registerForm.get('email').touched,
                'is-valid': registerForm.get('email').valid && !emailExist && emailValid && registerForm.get('email').touched
              }">
              <input matInput placeholder="Email" formControlName="email" type="email" npDetectFocus #ipEmail="detectFocus" (blur)="emailExist = false"
              />
            </mat-form-field>
            <div *ngIf="
            registerForm.get('email').hasError('required') && registerForm.get('email').touched && !ipEmail.isFocus
          ">
              <p class="error-message">Please enter valid information here.</p>
            </div>
            <div *ngIf="registerForm.get('email').hasError('email') && registerForm.get('email').touched && !ipEmail.isFocus">
              <p class="error-message">Email is incorrect format.</p>
            </div>
          </div>
          <div class="button">
            <button type="submit" (click)="createAccount()" class="btn btn-lg btn-block" [ngClass]="{
                'btn-greengo': registerForm.valid,
                'btn-inactive': !registerForm.valid
              }" npFocusOutClicked>Create Account</button>

          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!!customerTypeNumber">
  <div class="container px-0">
    <div class="col-md-8 col-lg-6 mx-auto register-form">
      <form [formGroup]="individualForm" class="individualForm">
        <div class="form-group d-flex">
          <div class="col-4 p-0">
            <mat-form-field [ngClass]="{
                    'is-invalid': !titleICtrl.valid && titleICtrl.touched,
                    'is-valid': titleICtrl.valid && titleICtrl.touched
                  }">
              <mat-select placeholder="Title" formControlName="title" npDetectFocus #ipITitle="detectFocus">
                <mat-option *ngFor="let title1 of titles" [value]="title1">
                  {{ title1.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="!titleICtrl.valid && titleICtrl.touched && !ipITitle.isFocus">
              <p class="error-message">Please enter valid information here</p>
            </div>
          </div>

          <div class="col-8 pr-0">
            <mat-form-field [ngClass]="{
                    'is-invalid': !firstNameICtrl.valid && firstNameICtrl.touched,
                    'is-valid': firstNameICtrl.valid && firstNameICtrl.touched
                  }">
              <input type="text" class="capitalize-field" matInput placeholder="First Name" formControlName="firstName" npDetectFocus #ipIFName="detectFocus" maxlength="255"
              />
            </mat-form-field>
            <div *ngIf="firstNameICtrl.hasError('required') && firstNameICtrl.touched && !ipIFName.isFocus" class="error-message">
              Please enter valid information here
            </div>
            <div *ngIf="firstNameICtrl.hasError('pattern') && firstNameICtrl.touched && !ipIFName.isFocus" class="error-message">
              {{ commonMessage.messageForSafeCharactersField }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                  'is-invalid': !middleNameICtrl.valid && middleNameICtrl.touched,
                  'is-valid': middleNameICtrl.valid && middleNameICtrl.touched
                }">
            <input matInput class="capitalize-field" placeholder="Middle Name(s)" formControlName="middleName" type="text" npDetectFocus #ipMiddleName="detectFocus" maxlength="255"/>
          </mat-form-field>
          <span class="optional">Optional</span>
          <div *ngIf="!middleNameICtrl.valid && middleNameICtrl.touched && !ipMiddleName.isFocus" class="error-message">
            {{ commonMessage.messageForSafeCharactersField }}
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                  'is-invalid': !lastNameICtrl.valid && lastNameICtrl.touched,
                  'is-valid': lastNameICtrl.valid && lastNameICtrl.touched
                }">
            <input matInput class="capitalize-field" placeholder="Last Name" formControlName="lastName" npDetectFocus #ipILName="detectFocus" maxlength="255"/>
          </mat-form-field>
          <div *ngIf="lastNameICtrl.hasError('required') && lastNameICtrl.touched && !ipILName.isFocus" class="error-message">
            Please enter valid information here
          </div>
          <div *ngIf="lastNameICtrl.hasError('pattern') && lastNameICtrl.touched && !ipILName.isFocus" class="error-message">
            {{ commonMessage.messageForSafeCharactersField }}
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                  'is-invalid': ((!emailICtrl.valid && emailICtrl.touched && !ipIEmail.isFocus) || (emailICtrl.valid && individualForm.hasError('emailnotmatch') && confirmEmailICtrl.value && !ipIEmail.isFocus && !ipConfEmail.isFocus)) && !readonlyEmail,
                  'is-valid': emailICtrl.valid && !individualForm.hasError('emailnotmatch') && !readonlyEmail && !ipIEmail.isFocus && !ipConfEmail.isFocus
                }">
            <input matInput placeholder="Email" formControlName="email" type="email" [readonly]="readonlyEmail" npDetectFocus #ipIEmail="detectFocus"
            />
          </mat-form-field>

          <div *ngIf="!emailICtrl.valid && emailICtrl.touched && !ipIEmail.isFocus && !readonlyEmail">
            <p class="error-message">Please enter valid information here</p>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                  'is-invalid': individualForm.hasError('emailnotmatch') && emailICtrl.valid && confirmEmailICtrl.touched && !readonlyEmail && !ipIEmail.isFocus && !ipConfEmail.isFocus,
                  'is-valid': emailICtrl.valid && !individualForm.hasError('emailnotmatch') && !readonlyEmail && !ipIEmail.isFocus && !ipConfEmail.isFocus
                }">
            <input matInput placeholder="Confirm Email" formControlName="confirmEmail" type="email" [readonly]="readonlyEmail" npDetectFocus
              #ipConfEmail="detectFocus" />
          </mat-form-field>
          <div class="error-message" *ngIf="
              emailICtrl.valid &&
              !confirmEmailICtrl.value &&
              !ipConfEmail.isFocus &&
              !ipIEmail.isFocus &&
              !readonlyEmail
            ">
            Please confirm your email
          </div>
          <div class="error-message" *ngIf="
                  emailICtrl.valid &&
                  individualForm.hasError('emailnotmatch') &&
                  confirmEmailICtrl.value &&
                  !ipConfEmail.isFocus &&
                  !ipIEmail.isFocus &&
                  !readonlyEmail
                ">
            Email and Confirm email do not match.
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                'is-invalid': !individualForm.get('country').valid && individualForm.get('country').touched,
                'is-valid': individualForm.get('country').valid && individualForm.get('country').touched
              }">
            <mat-select placeholder="Country" formControlName="country" npDetectFocus #ipCountry="detectFocus">
              <mat-option *ngFor="let country of countries" [value]="country.id">
                <span class="ml-3">{{ country.name }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="error-message" *ngIf="!individualForm.get('country').valid && individualForm.get('country').touched && !ipCountry.isFocus">
            Please input information here
          </div>
        </div>

        <ng-container *ngIf="customerTypeNumber === leadTypeEnum.Affiliate || customerTypeNumber === leadTypeEnum.MarketsPartner">
          <div class="form-group">
            <mat-form-field [ngClass]="{
                    'is-invalid': !companyRegNoPCtrl.valid && companyRegNoPCtrl.touched,
                    'is-valid': companyRegNoPCtrl.valid && companyRegNoPCtrl.touched
                  }">
              <input matInput placeholder="Company Reg. No." formControlName="companyRegNo" npDetectFocus #ipPCompanyNo="detectFocus" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
              />
            </mat-form-field>
            <span class="optional">Optional</span>
            <div *ngIf="!companyRegNoPCtrl.valid && companyRegNoPCtrl.touched">
              <p class="error-message">Please enter valid information here</p>
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                    'is-invalid': !businessNamePCtrl.valid && businessNamePCtrl.touched,
                    'is-valid': businessNamePCtrl.valid && businessNamePCtrl.touched
                  }">
              <input matInput placeholder="Business Name" formControlName="businessName" type="text" npDetectFocus #ipPBusinessName="detectFocus"
                maxlength="100" />
            </mat-form-field>
            <span class="optional">Optional</span>
          </div>
        </ng-container>

        <ng-container *ngIf="customerTypeNumber === leadTypeEnum.Corporate || customerTypeNumber === leadTypeEnum.MarketsCorporate || customerTypeNumber === leadTypeEnum.MarketsInstitution">
          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-invalid': !individualForm.get('businessNameCor').valid && individualForm.get('businessNameCor').touched,
              'is-valid': individualForm.get('businessNameCor').valid && individualForm.get('businessNameCor').touched
            }">
              <input matInput placeholder="Business Name" formControlName="businessNameCor" type="text" />
            </mat-form-field>
            <div class="error-message" *ngIf="!individualForm.get('businessNameCor').valid && individualForm.get('businessNameCor').touched">
              Please enter valid information here
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-invalid': !individualForm.get('companyRegNoCor').valid && individualForm.get('companyRegNoCor').touched,
              'is-valid': individualForm.get('companyRegNoCor').valid && individualForm.get('companyRegNoCor').touched
            }">
              <input matInput placeholder="Company Registration number" formControlName="companyRegNoCor" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
              />
            </mat-form-field>
            <span class="optional">Optional</span>
          </div>
        </ng-container>

        <div class="form-group">
          <div class="phone-row" [ngClass]="{
                  'is-invalid': (!individualForm.get('contactNumber').valid || !individualForm.get('callingCode').valid) && individualForm.get('contactNumber').touched && individualForm.get('callingCode').touched && !ipPhone.isFocus && !ipCallingCode.isFocus,
                  'is-valid': individualForm.get('contactNumber').valid && individualForm.get('callingCode').valid && individualForm.get('contactNumber').touched && individualForm.get('callingCode').touched && !ipPhone.isFocus && !ipCallingCode.isFocus
                }">
            <div class="col-4 px-0 left-panel">
              <mat-form-field>
                <mat-select formControlName="callingCode" placeholder="Calling code" #singleSelect npDetectFocus #ipCallingCode="detectFocus">
                  <ngx-mat-select-search [placeholderLabel]="'Find calling code...'" [noEntriesFoundLabel]="'No matching calling code found'"
                    formControlName="callingCodeFilter"></ngx-mat-select-search>
                  <mat-select-trigger>
                    <span class="{{individualForm.get('callingCode').value.countryCode | flagIcon}}"></span>&nbsp;
                    <span>{{individualForm.get('callingCode').value.code}}</span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let callingCode of (filteredCallingCodes | async)" [value]="callingCode">
                    <span [class]="callingCode.countryCode | flagIcon"></span>&nbsp;
                    <span>{{ callingCode.code }}</span>&nbsp;
                    <span>{{ callingCode.countryName }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-8 px-0">
              <mat-form-field>
                <input matInput placeholder="Contact number" formControlName="contactNumber" npDetectFocus #ipPhone="detectFocus" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
                />
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="(!individualForm.get('contactNumber').valid || !individualForm.get('callingCode').valid) && individualForm.get('contactNumber').touched && individualForm.get('callingCode').touched && !ipPhone.isFocus && !ipCallingCode.isFocus">
            <p class="error-message">Please enter valid information here</p>
          </div>
        </div>



        <ng-container *ngIf="!(customerTypeNumber === leadTypeEnum.Corporate || customerTypeNumber === leadTypeEnum.MarketsCorporate || customerTypeNumber === leadTypeEnum.MarketsInstitution)">
          <div class="form-group">
            <mat-form-field [ngClass]="{
                    'is-invalid': ((!pinCodeICtrl.valid || wrongPin) && pinCodeICtrl.touched && !ipIPin.isFocus) || (individualForm.hasError('pinnotmatch') && confirmPinICtrl.value && pinCodeICtrl.valid && !ipICPin.isFocus && !ipIPin.isFocus),
                    'is-valid': pinCodeICtrl.valid && !wrongPin && !individualForm.hasError('pinnotmatch') && !ipICPin.isFocus && !ipIPin.isFocus
                  }">
              <input matInput placeholder="Create your 6 digit Memorable Number" formControlName="pinCode" type="password" npDetectFocus
                #ipIPin="detectFocus" maxlength="6" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
              />
            </mat-form-field>
            <div *ngIf="pinCodeICtrl.hasError('required') && pinCodeICtrl.touched && !ipIPin.isFocus">
              <p class="error-message">Please enter valid information here</p>
            </div>
            <div class="error-message" *ngIf="(wrongPin || pinCodeICtrl.hasError('minlength')) && !ipIPin.isFocus">
              Memorable Number has 6 numeric characters and no repetition or sequencing.
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                    'is-invalid': individualForm.hasError('pinnotmatch') && confirmPinICtrl.touched && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus,
                    'is-valid': !individualForm.hasError('pinnotmatch') && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus
                  }">
              <input matInput placeholder="Confirm 6 digit Memorable Number" formControlName="confirmPin" type="password" npDetectFocus
                #ipICPin="detectFocus" maxlength="6" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
              />
            </mat-form-field>
            <div class="error-message" *ngIf="!confirmPinICtrl.value && confirmPinICtrl.touched && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus">
              Please confirm your memorable number
            </div>
            <div class="error-message" *ngIf="confirmPinICtrl.value && individualForm.hasError('pinnotmatch') && pinCodeICtrl.valid && !wrongPin && !ipICPin.isFocus && !ipIPin.isFocus">
              Memorable number and Confirm memorable number do not match
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                    'is-invalid': (!passwordICtrl.valid && passwordICtrl.touched && !ipIPass.isFocus) || (individualForm.hasError('passnotmatch') && confirmPassICtrl.value && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus),
                    'is-valid': passwordICtrl.valid && !individualForm.hasError('passnotmatch') && !ipICPass.isFocus && !ipIPass.isFocus
                  }">
              <input matInput placeholder="Create your Password" formControlName="password" type="password" (keypress)="($event.charCode !== 32)"
                npDetectFocus #ipIPass="detectFocus" />
            </mat-form-field>
            <div *ngIf="passwordICtrl.hasError('required') && passwordICtrl.touched && !ipIPass.isFocus">
              <p class="error-message">Please enter valid information here</p>
            </div>
            <div *ngIf="passwordICtrl.hasError('pattern') && !ipIPass.isFocus">
              <p class="error-message">
                The password must be at least 8 characters and must contain at least one number, one upper case character and one special
                character.
              </p>
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                    'is-invalid': individualForm.hasError('passnotmatch') && passwordICtrl.valid && confirmPassICtrl.touched && !ipICPass.isFocus && !ipIPass.isFocus,
                    'is-valid': !individualForm.hasError('passnotmatch') && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus
                  }">
              <input matInput placeholder="Confirm your Password" formControlName="confirmPass" type="password" npDetectFocus #ipICPass="detectFocus"
              />
            </mat-form-field>
            <div *ngIf="!confirmPassICtrl.value && confirmPassICtrl.touched && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus">
              <p class="error-message">Please confirm your password</p>
            </div>
            <div class="error-message" *ngIf="individualForm.hasError('passnotmatch') && confirmPassICtrl.value && passwordICtrl.valid && !ipICPass.isFocus && !ipIPass.isFocus">
              Password and Confirm password do not match
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="customerTypeNumber === leadTypeEnum.Affiliate || customerTypeNumber === leadTypeEnum.MarketsPartner">
          <div class="form-group">
            <mat-form-field [ngClass]="{'is-valid': individualForm.get('partnerResidency').valid && individualForm.get('partnerResidency').touched}">
              <mat-select placeholder="What is the residency of the partner" formControlName="partnerResidency">
                <mat-option *ngFor="let partnerResidency of partnerResidencies" [value]="partnerResidency.id">
                  <span class="ml-3">{{ partnerResidency.name }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="">
            <mat-checkbox class="break-line greengo" disableRipple [checked]="isVATRegistered" (change)="isVATRegistered = !isVATRegistered">Are you/Is the Company (dependant on if individual or corporate registration) VAT registered?</mat-checkbox>
          </div>
          <div class="form-group" *ngIf="isVATRegistered">
            <mat-form-field [ngClass]="{'is-valid': individualForm.get('vatNumber').valid && individualForm.get('vatNumber').touched}">
              <input matInput placeholder="VAT number" formControlName="vatNumber" />
            </mat-form-field>
          </div>
          <div class="form-group" *ngIf="isVATRegistered">
            <mat-form-field [ngClass]="{'is-valid': individualForm.get('vatCountry').valid && individualForm.get('vatCountry').touched}">
              <mat-select placeholder="VAT country" formControlName="vatCountry">
                <mat-option *ngFor="let country of countries" [value]="country.code">
                  <span class="ml-3">{{ country.name }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <mat-checkbox class="greengo break-line" disableRipple [checked]="acceptMarketingEmails" (change)="acceptMarketingEmails = !acceptMarketingEmails">Yes, I would like to be sent marketing communications and updates</mat-checkbox>
        <div class="form-group">
          <mat-checkbox class="greengo" disableRipple [checked]="acceptPolicy" (change)="acceptPolicy = !acceptPolicy">Accept
            <a target="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/privacy-policy" class="privacy-policy">Privacy & Cookie</a>
            policy
          </mat-checkbox>
          <div class="error-message" *ngIf="!acceptPolicy && submitForm">
            Please accept the Privacy & Cookie Policy to Proceed
          </div>
        </div>

        <div class="form-group">
          <re-captcha  #captchaRef="reCaptcha" formControlName="recaptchaReactive" [siteKey]="recaptchaV2SiteKey" (resolved)="resolvedRecaptchaChallenge($event)"></re-captcha>
        </div>

        <div class="row" *ngIf="readonlyEmail">
          <div class="col-6">
            <button class="btn btn-lg btn-block btn-greengo-o" (click)="back()" type="button">Back</button>
          </div>
          <div class="col-6">
            <button class="btn btn-lg btn-block" type="submit" (click)="individualSubmit()" [ngClass]="{
                'btn-greengo': individualForm.valid && !wrongPin && acceptPolicy,
                'btn-inactive': !individualForm.valid || wrongPin || !acceptPolicy
              }" npFocusOutClicked>Next</button>
          </div>
        </div>
        <div class="row" *ngIf="!readonlyEmail">
          <div class="col-12">
            <button class="btn btn-lg btn-block" type="submit" (click)="individualSubmit()" [ngClass]="{
                'btn-greengo': individualForm.valid && !wrongPin && acceptPolicy,
                'btn-inactive': !individualForm.valid || wrongPin || !acceptPolicy
              }" npFocusOutClicked>Create account</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</ng-container>
